module.exports = __webpack_public_path__ + "img/8.f24aec12.png";